
















import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars

@Component
export default class CdkImagePlaceholder extends Vue {
  @Prop({ required: true }) showText!: boolean;

  @Prop({ default: "horizontal" }) ratio?: "horizontal" | "vertical" | "square";

  /**
   * Returns the image ratio modifier class name
   */
  get modifier(): string {
    let ratio = "1by1";

    if (this.ratio === "horizontal") {
      ratio = "3by2";
    } else if (this.ratio === "vertical") {
      ratio = "2by3";
    }
    return `FlexEmbed-ratio--${ratio}`;
  }
}
